import React from 'react';
import './FooterTitle.css'

const FooterTitle = (props) => {
    return ( <>
        <div className={props.style2} > {props.text}</div>
    </> );
}
 
export default FooterTitle;